export default function mergeByCommonKeys(a1, a2, key) {
    return a1.map((item) => ({
        ...a2.find((x) => x[key] === item[key] && item),
        ...item,
    }));
}
